<template>
  <button :class="_class">
    <input
      v-on="listeners"
      type="checkbox"
      :value="checked"
      :class="_inputClass"
      :disabled="disabled"
      @change="onChange"
    >
    <span :class="_textClass">
      <slot v-bind="{ checked: checked }" />
    </span>
  </button>
</template>

<script>
const name = 'ten-switch';

export default {
  name,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    /**
     * 当前是否选中
     * @model checked
     */
    checked: Boolean,
    /**
     * 初始是否选中
     */
    defaultChecked: Boolean,
    /**
     * 是否禁用
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    _class() {
      return [
        `${name}`,
        {
          'ten-switch--disabled': this.disabled,
          'ten-switch--ischecked': this.checked,
          'ten-switch--unchecked': !this.checked,
        },
      ];
    },
    _inputClass() {
      return [`${name}__checkinput`];
    },
    _textClass() {
      return [`${name}__text`];
    },
    listeners() {
      const { change, ...others } = this.$listeners;
      return others;
    },
  },
  methods: {
    onChange() {
      /**
       * 选中事件
       */
      this.$emit('change', !this.checked);
    },
  },
};
</script>
